import winnipeg from './cities/winnipeg'

export default {
  'province': 'Manitoba',
  'abbr': 'Man.',
  'alpha': 'MB',
  'lawSociety': 'Law Society of Manitoba',
  'writeup': '',
  'cities': [
    winnipeg
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/manitoba/index.js